import * as React from 'react';
import { TAdfoxBannerSizeProps } from 'shared/types/microfrontends/adBanner';

interface IAdBannerPlaceholderProps {
  sizes: TAdfoxBannerSizeProps;
  children: React.ReactNode;
  testId?: string;
}

export const AdBannerPlaceholder: React.FC<IAdBannerPlaceholderProps> = ({ sizes, children, testId }) => (
  <div
    data-testid={testId}
    style={{
      width: sizes.width,
      height: sizes.height,
      minHeight: sizes.height,
    }}
  >
    {children}
  </div>
);
